const calcBound = (len, top) => {
  if (top) {
    return 0
  }

  return len
}

export const initialState = (slice, childrenLength, top) => ({
  size: slice,
  slice,
  bound: calcBound(childrenLength, top),
  canLoad: true,
  done: false
})

export const Actions = {
  UPDATE_BOUND: 'UPDATE_BOUND',
  START_LOAD: 'START_LOAD',
  FINISH_LOAD: 'FINISH_LOAD',
  ALL_LOADED: 'ALL_LOADED',
  CAN_LOAD: 'CAN_LOAD',
  ALL_INFINITE_SWR_LOADED: 'ALL_INFINITE_SWR_LOADED'
}

const handleUpdateBound = (state, action) => {
  const { childrenLength, top } = action

  return { ...state, bound: calcBound(childrenLength, top), done: false }
}

const handleStartLoad = (state, action) => {
  if (!state.canLoad) {
    return state
  }

  const { cb } = action

  cb()

  return { ...state, canLoad: false }
}

const handleFinishLoad = (state, _) => {
  const size = state.size + state.slice

  return {
    ...state,
    canLoad: true,
    size
  }
}

const handleAllLoaded = (state, _) => {
  return { ...state, done: true }
}
const handleAllInfiniteSwrLoaded = (state, _) => {
  return { ...state, canLoad: true, done: true }
}

const handleCanLoad = (state, _) => {
  return { ...state, canLoad: true }
}

const Handlers = {
  [Actions.UPDATE_BOUND]: handleUpdateBound,
  [Actions.START_LOAD]: handleStartLoad,
  [Actions.FINISH_LOAD]: handleFinishLoad,
  [Actions.ALL_LOADED]: handleAllLoaded,
  [Actions.CAN_LOAD]: handleCanLoad,
  [Actions.ALL_INFINITE_SWR_LOADED]: handleAllInfiniteSwrLoaded
}

export const infiniteReducer = (state, action) => {
  const { type } = action

  if (type in Handlers) {
    return Handlers[type](state, action)
  }

  throw new Error(`Unknown infinite reducer type: ${type}`)
}
